import React, { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import api from "../../lib/api";

const PHRASE = "WIPE LIVE DATABASE";

// Clean slate: removes every player and all game data (payment records are kept).
export function WipePanel() {
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(null);

  const run = async () => {
    if (confirm !== PHRASE) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/wipe", { confirm: PHRASE });
      setStatus({ ok: true, text: `Wiped ${data.collections} collections (${data.total_docs.toLocaleString()} documents). Signing out…` });
      toast.success("Database wiped");
      setTimeout(() => window.location.assign("/"), 2500);
    } catch (e) {
      const d = e.response?.data?.detail;
      setStatus({ ok: false, text: `Wipe failed: ${typeof d === "string" ? d : "unknown error"}` });
      setBusy(false);
    }
  };

  return (
    <div className="rounded-xl border border-[#FF007F] bg-[#12082B] p-4 space-y-3" data-testid="admin-wipe-panel">
      <div className="font-heading text-sm neon-pink flex items-center gap-2"><Trash2 size={16} /> Wipe database</div>
      <div className="font-mono text-xs text-[#A89BCC]">
        Deletes EVERY player account, wrestler, chat, show, title, promotion and log on this site's database. Stripe payment records are kept. No backup is made and it cannot be undone. Everyone (including you) is signed out; admins regain access by signing in again.
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <input data-testid="admin-wipe-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} disabled={busy}
          placeholder={`Type ${PHRASE} to confirm`}
          className="px-2 py-1.5 rounded-lg bg-[#0A051A] border border-[#FF007F]/40 font-mono text-xs w-64" />
        <button data-testid="admin-wipe-btn" disabled={busy || confirm !== PHRASE} onClick={run}
          className="px-3 py-1.5 rounded-lg bg-[#FF007F]/20 border border-[#FF007F] text-[#FF007F] hover:bg-[#FF007F]/30 font-heading text-xs uppercase tracking-widest disabled:opacity-40">
          {busy ? "Wiping…" : "Wipe everything"}
        </button>
      </div>
      {status && <div data-testid="admin-wipe-status" className="font-mono text-xs" style={{ color: status.ok ? "#39FF14" : "#FF007F" }}>{status.text}</div>}
    </div>
  );
}
